// Improved cart drawer implementation with error handling
(function() {
  // Fix for the updateURL error in product-info.js
  if (customElements.get('product-info')) {
    try {
      // Get the original prototype of the product-info element
      const originalProductInfo = customElements.get('product-info').prototype;
      
      // Save the original updateURL method
      const originalUpdateURL = originalProductInfo.updateURLs;
      
      // Override the updateURL method to add error checking
      originalProductInfo.updateURL = function(url, variantId) {
        try {
          // Add safe check for share-button's updateUrl method
          const shareButton = this.querySelector('share-button');
          if (shareButton && typeof shareButton.updateUrl === 'function') {
            shareButton.updateUrl(`${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`);
          }
          
          if (this.dataset.updateUrl === 'false') return;
          window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
        } catch (error) {
          console.warn('Error in updateURL method:', error);
        }
      };
      
      console.log('Fixed product-info updateURL method');
    } catch (error) {
      console.warn('Could not patch product-info element:', error);
    }
  }
  
  // Cart Drawer Implementation
  const initCartDrawer = () => {
    // Create or use existing cart drawer
    let cartDrawer = document.querySelector('.cart-drawer');
    
    if (!cartDrawer) {
      // Create cart drawer elements
      cartDrawer = document.createElement('div');
      cartDrawer.className = 'cart-drawer';
      cartDrawer.innerHTML = `
        <div class="cart-drawer-header">
          <h2 class="cart-drawer-heading">Your Cart</h2>
          <button class="cart-drawer-close" aria-label="Close cart">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div class="cart-drawer-empty">
          <p class="cart-drawer-empty-message">Your cart is currently empty.</p>
          <a href="/collections/all" class="cart-drawer-continue">Continue Shopping</a>
        </div>
        <cart-drawer-items class="cart-drawer-items"></cart-drawer-items>
        <div class="cart-drawer-footer">
          <div class="cart-drawer-subtotal">
            <span>Subtotal</span>
            <span class="cart-drawer-subtotal-price">$0.00</span>
          </div>
          <button class="cart-drawer-checkout">Checkout</button>
          <a href="/cart" class="cart-drawer-view-cart">View Cart</a>
        </div>
      `;
      
      // Create overlay
      const overlay = document.createElement('div');
      overlay.className = 'cart-drawer-overlay';
      
      // Append elements to body
      document.body.appendChild(cartDrawer);
      document.body.appendChild(overlay);
      
      // Add event listeners for opening/closing
      const closeBtn = cartDrawer.querySelector('.cart-drawer-close');
      closeBtn.addEventListener('click', toggleCartDrawer);
      overlay.addEventListener('click', toggleCartDrawer);
      
      // Checkout button functionality
      const checkoutBtn = cartDrawer.querySelector('.cart-drawer-checkout');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function() {
          window.location.href = '/checkout';
        });
      }
      
      // Define cart-drawer-items element if not already defined
      if (!customElements.get('cart-drawer-items')) {
        customElements.define('cart-drawer-items', class CartDrawerItems extends HTMLElement {
          constructor() {
            super();
            this._isUpdating = false;
          }
          
          connectedCallback() {
            // Initialize the cart drawer items
            this.updateCartItems();
          }
          
          updateCartItems() {
            // Prevent multiple simultaneous updates
            if (this._isUpdating) return Promise.resolve();
            this._isUpdating = true;
            
            // Add loading indicator
            this.classList.add('is-loading');
            
            return fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
              .then(response => {
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.text();
              })
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Update cart items
                const cartItems = doc.querySelector('.cart-drawer-items');
                if (cartItems) {
                  this.innerHTML = cartItems.innerHTML;
                }
                
                // Update subtotal price
                const subtotal = doc.querySelector('.cart-drawer-subtotal-price');
                if (subtotal) {
                  const subtotalElement = document.querySelector('.cart-drawer-subtotal-price');
                  if (subtotalElement) {
                    subtotalElement.textContent = subtotal.textContent;
                  }
                }
                
                // Show/hide empty state
                const cartItemElements = this.querySelectorAll('.cart-item');
                const isEmpty = cartItemElements.length === 0;
                const emptyState = document.querySelector('.cart-drawer-empty');
                const footer = document.querySelector('.cart-drawer-footer');
                
                if (emptyState) emptyState.style.display = isEmpty ? 'block' : 'none';
                if (footer) footer.style.display = isEmpty ? 'none' : 'block';
                
                return cartItemElements.length;
              })
              .catch(error => {
                console.error('Error updating cart drawer:', error);
              })
              .finally(() => {
                // Remove loading indicator and reset flag
                this.classList.remove('is-loading');
                this._isUpdating = false;
              });
          }
          
          updateQuantity(line, quantity) {
            // Prevent updates if already processing
            if (this._isUpdating) return;
            this._isUpdating = true;
            
            // Add loading indicator to specific item
            const lineItem = this.querySelector(`[data-line="${line}"]`);
            if (lineItem) {
              lineItem.classList.add('is-loading');
            }
            
            const body = JSON.stringify({
              line,
              quantity,
              sections: ['cart-drawer'],
              sections_url: window.location.pathname
            });
            
            fetch(`${window.routes.cart_change_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body
            })
            .then(response => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json();
            })
            .then(data => {
              return this.updateCartItems();
            })
            .then(() => {
              // Update cart count in header
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  const cartCountBubble = document.querySelector('.cart-count-bubble span');
                  if (cartCountBubble) {
                    cartCountBubble.textContent = cart.item_count;
                    cartCountBubble.closest('.cart-count-bubble').style.display = 
                      cart.item_count > 0 ? 'flex' : 'none';
                  }
                })
                .catch(error => {
                  console.warn('Failed to update cart count:', error);
                });
            })
            .catch(error => {
              console.error('Error updating cart:', error);
            })
            .finally(() => {
              if (lineItem) {
                lineItem.classList.remove('is-loading');
              }
              this._isUpdating = false;
            });
          }
        });
      }
      
      // Define cart-remove-button if not already defined
      if (!customElements.get('cart-drawer-remove-button')) {
        customElements.define('cart-drawer-remove-button', class CartDrawerRemoveButton extends HTMLElement {
          constructor() {
            super();
            
            this.addEventListener('click', event => {
              event.preventDefault();
              const cartItems = this.closest('cart-drawer-items');
              if (cartItems) {
                const lineItem = this.closest('[data-line]');
                const line = lineItem ? lineItem.dataset.line : this.dataset.index;
                cartItems.updateQuantity(line, 0);
              }
            });
          }
        });
      }
      
      console.log('Cart drawer initialized');
    }
    
    // Add click listener to cart icon in header
    const cartIcons = document.querySelectorAll('a[href="/cart"], a[href="/cart/"]');
    cartIcons.forEach(cartIcon => {
      cartIcon.addEventListener('click', function(event) {
        event.preventDefault();
        toggleCartDrawer();
      });
    });
    
    // Setup a global event for the "Add to Cart" functionality
    window.addEventListener('product:added-to-cart', function() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems && typeof cartDrawerItems.updateCartItems === 'function') {
        cartDrawerItems.updateCartItems().then(() => {
          if (!cartDrawer.classList.contains('active')) {
            toggleCartDrawer();
          }
        });
      } else {
        // Fallback if custom element isn't ready
        setTimeout(() => {
          toggleCartDrawer();
        }, 500);
      }
    });
    
    // Intercept "Add to Cart" button clicks
    document.addEventListener('click', function(event) {
      if (event.target.matches('button[name="add"]') || event.target.closest('button[name="add"]')) {
        // Wait for the form submission and cart update to complete
        setTimeout(() => {
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          
          // Safely check if the element exists and has the method
          if (cartDrawerItems && typeof cartDrawerItems.updateCartItems === 'function') {
            // Wait for the cart to update, then open drawer
            cartDrawerItems.updateCartItems().then(() => {
              if (!cartDrawer.classList.contains('active')) {
                toggleCartDrawer();
              }
            });
          } else {
            // Fallback if custom element isn't ready
            if (!cartDrawer.classList.contains('active')) {
              toggleCartDrawer();
            }
          }
        }, 500);
      }
    });
    
    // Setup form submit handler for add to cart forms
    document.addEventListener('submit', function(event) {
      const form = event.target;
      // Check if this is an add to cart form
      if (form.action && form.action.includes('/cart/add')) {
        // We'll let the form submit normally, but we'll open the cart drawer after
        window.setTimeout(() => {
          const event = new CustomEvent('product:added-to-cart');
          window.dispatchEvent(event);
        }, 500);
      }
    });
  };
  
  // Toggle cart drawer function with safety checks and improved error handling
  window.toggleCartDrawer = function() {
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-drawer-overlay');
    
    // If elements don't exist, create them before proceeding
    if (!drawer || !overlay) {
      console.log('Creating cart drawer elements before opening');
      // Give time for initialization to complete
      setTimeout(() => {
        tryInitialize(); // Attempt to initialize cart drawer
        
        // Try again after initialization
        const newDrawer = document.querySelector('.cart-drawer');
        const newOverlay = document.querySelector('.cart-drawer-overlay');
        if (newDrawer && newOverlay) {
          newDrawer.classList.add('active');
          newOverlay.classList.add('active');
          document.body.style.overflow = 'hidden';
          
          // Update cart content when opened
          const cartDrawerItems = document.querySelector('cart-drawer-items');
          if (cartDrawerItems && typeof cartDrawerItems.updateCartItems === 'function') {
            cartDrawerItems.updateCartItems();
          }
        } else {
          console.warn('Cart drawer elements still not found after initialization attempt');
        }
      }, 100);
      return;
    }
    
    // Continue with normal operation if elements exist
    drawer.classList.toggle('active');
    overlay.classList.toggle('active');
    
    if (drawer.classList.contains('active')) {
      document.body.style.overflow = 'hidden';
      
      // Update cart content when opened
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (cartDrawerItems && typeof cartDrawerItems.updateCartItems === 'function') {
        cartDrawerItems.updateCartItems();
      }
    } else {
      document.body.style.overflow = '';
    }
  };
  
  // Initialize when the DOM is fully loaded with retry logic
  let retryCount = 0;
  const maxRetries = 3;
  
  function tryInitialize() {
    try {
      initCartDrawer();
    } catch (error) {
      console.warn(`Cart drawer initialization failed (attempt ${retryCount + 1}/${maxRetries}):`, error);
      if (retryCount < maxRetries) {
        retryCount++;
        setTimeout(tryInitialize, 1000); // Retry after 1 second
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitialize);
  } else {
    tryInitialize();
  }
})();